import React from 'react';
import FullPageSection from './FullPageSection';
import './AboutSection.css';

const AboutSection = () => {
    const services = [
        'Branding & Rebranding',
        'Web Design & UI/UX',
        'Identidade Visual',
        'Packaging & Editorial',
        'Comunicação Digital'
    ];

    return (
        <FullPageSection id="about" className="about-section">
            <div className="about-container">
                <div className="about-header">
                    <span className="section-label">Sobre a MAP</span>
                    <h2 className="section-title">
                        Uma agência de design<br />
                        focada em resultados
                    </h2>
                </div>

                <div className="about-content">
                    <div className="about-text">
                        <p className="about-description">
                            A MAPDESIGN é um creative studio especializado em criar marcas fortes e experiências digitais 
                            que geram impacto real. Trabalhamos com empresas que procuram uma presença 
                            moderna, diferenciada e orientada para resultados.
                        </p>
                        <p className="about-description">
                            A nossa abordagem combina estratégia criativa com design de excelência, 
                            sempre com foco em comunicar a essência da sua marca de forma clara e memorável.
                        </p>
                    </div>

                    <div className="about-services">
                        <h3>O que fazemos</h3>
                        <ul className="services-list">
                            {services.map((service, index) => (
                                <li key={index} className="service-item">
                                    <span className="service-marker"></span>
                                    {service}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </FullPageSection>
    );
};

export default AboutSection;
